import { NLPEditorServiceImpl } from './services/NLPEditorService/impl';
import { TypedContainerModule } from '@thinkalpha/common/ioc/TypedContainer.js';
import type { ReactBindings } from 'src/types/bindings';

export const NLPEditorFeatureModule = new TypedContainerModule<ReactBindings>((bind) => {
    bind('NLPEditorService').to(NLPEditorServiceImpl);
});
